export class StepInfo {
  public ID: string = '';
  public title: string = '';
  public formName: string = '';
  public desc: string = '';
  public stepNumber: number = 0;
  public btnText: string = 'NEXT';
  public btnEnabled: boolean = false;
  public enabled: boolean = true;
  public get isDisabled(): boolean {
    return !this.enabled;
  }
}
